import React from 'react';

class DoorSensorIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_241_675)">
          <path
            d="M74 26.4661C74 21.7941 70.214 18.0081 65.542 18.0081C60.87 18.0081 57.084 21.7941 57.084 26.4661V53.53C57.084 58.202 60.87 61.988 65.542 61.988C70.214 61.988 74 58.202 74 53.53V26.4661Z"
            fill="#F7F4F1"
          />
          <path
            d="M65.5422 62.79C60.4382 62.79 56.2842 58.636 56.2842 53.532V26.466C56.2842 21.362 60.4362 17.208 65.5422 17.208C70.6482 17.208 74.8002 21.362 74.8002 26.466V53.53C74.8002 58.634 70.6462 62.788 65.5422 62.788V62.79ZM65.5422 18.81C61.3202 18.81 57.8842 22.246 57.8842 26.468V53.532C57.8842 57.754 61.3202 61.19 65.5422 61.19C69.7642 61.19 73.2002 57.754 73.2002 53.532V26.466C73.2002 22.244 69.7642 18.808 65.5422 18.808V18.81Z"
            fill="#84827E"
          />
          <path
            d="M48.626 27.314C48.626 15.542 39.084 6 27.312 6C15.54 6 6 15.542 6 27.314V52.688C6 64.46 15.542 74.002 27.314 74.002C39.086 74.002 48.628 64.46 48.628 52.688V27.314H48.626Z"
            fill="#F7F4F1"
          />
          <path
            d="M27.3142 74.8C15.1202 74.8 5.2002 64.88 5.2002 52.686V27.312C5.2002 15.118 15.1202 5.198 27.3142 5.198C39.5082 5.198 49.4282 15.118 49.4282 27.312V52.686C49.4282 64.88 39.5082 74.8 27.3142 74.8ZM27.3142 6.8C16.0022 6.8 6.8002 16.002 6.8002 27.314V52.688C6.8002 64 16.0022 73.202 27.3142 73.202C38.6262 73.202 47.8282 64 47.8282 52.688V27.314C47.8282 16.002 38.6262 6.8 27.3142 6.8Z"
            fill="#84827E"
          />
          <path
            d="M27.3136 57.97C28.744 57.97 29.9036 56.8105 29.9036 55.38C29.9036 53.9496 28.744 52.79 27.3136 52.79C25.8832 52.79 24.7236 53.9496 24.7236 55.38C24.7236 56.8105 25.8832 57.97 27.3136 57.97Z"
            fill="url(#paint0_linear_241_675)"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_241_675"
            x="3.8002"
            y="3.798"
            width="75.5996"
            height="75.6021"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_241_675"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_241_675"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_241_675"
            x1="25.4522"
            y1="53.2533"
            x2="28.9684"
            y2="57.2866"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
        </defs>
      </svg>
    );
  }
}

export default DoorSensorIcon;
